import TimeoutUtility from "./TimeoutUtility";

const validateEmail = (mail) => {
  TimeoutUtility.resetTimeout();
  if (/^\w+([\\.-]?\w+)*@\w+([\\.-]?\w+)*(\.\w{2,3})+$/.test(mail)) {
    return true;
  }
  return false;
};

function validateName(name) {
  TimeoutUtility.resetTimeout();
  if (/^[A-Za-z0-9\s-,/.+?()&*]+$/.test(name)) {
    return true;
  }
  return false;
}

function validateName2(name) {
  TimeoutUtility.resetTimeout();

  if (typeof name !== "string") return false;
  name = name.trim();

  // allow empty? change if you need to block empty strings:
  if (name.length === 0) return false;

  // Unicode-aware regex:
  // \p{Script=Arabic}  -> Arabic script (covers Urdu letters & diacritics)
  // A-Za-z0-9           -> basic latin letters and digits
  // \u06F0-\u06F9       -> Arabic-Indic digits (۰..۹) often used with Urdu
  // allowed punctuation: space, comma, hyphen, dot, slash, plus, question mark, parentheses, ampersand, asterisk
  // plus Urdu/Arabic punctuation: Arabic question mark (؟), Arabic comma (،), Urdu full stop (۔)
  const re =
    /^[\p{Script=Arabic}A-Za-z0-9\u06F0-\u06F9\s\-,\\/.+?()&*\u061F\u060C\u06D4]+$/u;

  return re.test(name);
}

const ValidPhone = (phone) => {
  TimeoutUtility.resetTimeout();
  // const phoneRegex = /^\d{10}$/;     /^[\d()+\s-]+$/
  if (
    /^(\(\d{1,3}\)\s*)?(\+?\d{1,3}(\s*-?\s*\d{1,3})*|\d{1,3}(\s*-?\s*\d{1,3})*)$/.test(
      phone
    )
  ) {
    return true;
  }
  return false;
};

const ValidWebsite = (web) => {
  if (
    /^(https?:\/\/)?(www\.)?([a-zA-Z0-9-]+\.){1,}([a-zA-Z]{2,})(:\d+)?(\/[a-zA-Z0-9-._~:/?#[\]@!$&'()*+,;%=]*)?$/.test(
      web
    )
  ) {
    return true;
  }
  return false;
};

const ValidAmount = (amount) => {
  TimeoutUtility.resetTimeout();
  if (/^(\d+|\d{1,3}(,\d{3})*)(\.\d+)?$/.test(amount)) {
    return true;
  }
  return false;
};

const ValidText = (text) => {
  TimeoutUtility.resetTimeout();
  if (/^[\w\s\d.,&()/\\-]+$/u.test(text) && !/[-']{2}|'/.test(text)) {
    return true;
  }
  return false;
};

const ValidOrderField = (text) => {
  TimeoutUtility.resetTimeout();
  if (/^[^+-]+$/u.test(text)) {
    return true;
  }
  return false;
};

export const getBase64ImageFromUrl = async (url) => {
  const res = await fetch(url);
  const blob = await res.blob();
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.readAsDataURL(blob);
  });
};

export {
  validateEmail,
  validateName,
  validateName2,
  ValidPhone,
  ValidWebsite,
  ValidAmount,
  ValidText,
  ValidOrderField,
};
